<template>
    <div>
        <transition name="popup">
            <div v-if="showPopup" class="popup-overlay" @click.self="closePopup">
                <div class="popup-container">

                    <button class="popup-close" @click="closePopup"><svg width="18" height="19" viewBox="0 0 18 19"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.494853 15.703C-0.144973 16.3298 -0.158031 17.4789 0.50791 18.1448C1.17385 18.8108 2.32293 18.7847 2.94969 18.1579L9.00845 12.0991L15.0672 18.1448C15.7201 18.7977 16.8431 18.8108 17.509 18.1318C18.1749 17.4658 18.1749 16.3429 17.5221 15.69L11.4764 9.64428L17.5221 3.58553C18.1749 2.93264 18.1749 1.80968 17.509 1.14374C16.8431 0.464742 15.7201 0.4778 15.0672 1.13068L9.00845 7.17638L2.94969 1.11763C2.32293 0.490858 1.17385 0.464742 0.50791 1.13068C-0.158031 1.79662 -0.144973 2.9457 0.494853 3.58553L6.55361 9.64428L0.494853 15.703Z"
                                fill="#FFFFFF" />
                        </svg></button>
                    <transition name="fade">
                        <!-- Ошибка 409: пользователь уже зарегистрирован (лимит 1 лид) -->
                        <div class="popup-content-success" v-if="errorSms">
                            <p class="otp-success-text">{{ $t('otp.alreadyRegistered') }}</p>
                        </div>

                        <!-- Успешная верификация кода -->
                        <div class="popup-content-success" v-else-if="success">
                            <p class="otp-success-text">{{ $t('otp.successText') }}</p>
                        </div>

                        <!-- Форма ввода кода -->
                        <div class="popup-content" v-else>
                            <div>
                                <div class="mb-5">
                                    <p class="otp-title">{{ $t('otp.title') }}</p>
                                    <p class="otp-description">{{ $t('otp.description') }}</p>
                                </div>
                                <div class="ma-auto position-relative" style="max-width: 300px">
                                    <v-otp-input v-model="otp" length="4" :disabled="loading" type="tel"></v-otp-input>
                                    <v-overlay absolute :value="loading">
                                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                    </v-overlay>
                                </div>

                                <div v-if="errorMessage" class="mt-2">
                                    <p class="code-error">{{ errorMessage || $t('otp.errorWrongCode') }}</p>
                                </div>

                                <div class="sms-timer mt-4">
                                    <p v-if="smsTimer > 0">{{ $t('otp.resendPrefix', { sec: smsTimer }) }}</p>
                                    <button v-else @click="$emit('resend')" class="resend-btn">{{ $t('otp.resendBtn') }}</button>
                                </div>

                                <div class="btn-container-success">
                                    <button class="btn-success" @click="confirmOtp"
                                        :disabled="loading">{{ loading ? $t('otp.sendingBtn') : $t('otp.confirmBtn') }}</button>
                                </div>
                            </div>
                        </div>
                    </transition>


                </div>
            </div>
        </transition>
    </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.4s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.popup-content-success {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    text-align: center;
    padding: 30px 24px;
    box-sizing: border-box;
}

.otp-success-text {
    font-weight: 700;
    font-size: 32px;
    color: var(--color-white, #FFFFFF);
    text-transform: uppercase;
    font-family: "MontserratBold", sans-serif;
    margin-bottom: 0px;
    line-height: 1.3;
    max-width: 100%;
    word-break: break-word;
    overflow-wrap: break-word;
}

.btn-container-success {
    margin-top: 36px;
}

.btn-success {
    border-radius: 10px;
    padding: 11px 42px;
    height: 59px;
    background: var(--color-white);
    font-family: "MontserratRegular";
    font-weight: 700;
    font-size: 20px;
    color: var(--color-primary-dark);
    cursor: pointer;
    box-shadow: 0 4px 0 #626266;

    /* медленный возврат */
    transition: all 0.4s ease;
}

/* При наведении (быстрее, чем возврат) */
.btn-success:hover {
    background: var(--color-white);
    transform: translateY(-2px);
    box-shadow: 0 6px 0 #49494d;

    /* ускоренный вход */
    transition: all 0.15s ease-out;
}

/* При нажатии */
.btn-success:active {
    background: var(--color-white);
    transform: translateY(2px);
    box-shadow: 0 2px 0 #434346;
    transition: all 0.1s ease-in;
}

.sms-timer .resend-btn {
    text-decoration: underline;
    font-family: "MontserratRegular";
    color: var(--color-white);
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
}

.sms-timer {
    font-size: 16px;
    color: var(--color-white);
    font-weight: regular;
    font-family: "MontserratRegular"
}

.code-error {
    color: #FE5050;
    font-size: 16px;
    margin-bottom: 0px;
    text-align: center;
}

::v-deep .v-otp-input input {
    text-align: center;
    font-size: 25px;
    font-weight: bold;
    color: black !important;
}
::v-deep .v-text-field--outlined fieldset {
  border: none !important;        /* убираем серую рамку */
  outline: none !important;       /* убираем выделение при фокусе */
  box-shadow: none !important;    /* убираем внутреннюю тень */
  border-radius: 0 !important;    /* убираем закругление сверху */
}

::v-deep .v-text-field--outlined>.v-input__control>.v-input__slot {
    align-items: stretch;
    min-height: 85px;
}

::v-deep .theme--light.v-otp-input .v-input .v-input__control .v-input__slot {
    background: var(--color-white);
}

.popup-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 30px 20px 20px 20px;
    box-sizing: border-box;
}

.otp-description {
    font-size: 20px;
    font-weight: 500;
    color: var(--color-white);
    font-family: "MontserratMedium";
    margin-bottom: 0px;
    max-width: 420px;
    margin: auto;
}

.otp-title {
    font-size: 40px;
    font-weight: 700;
    color: var(--color-white);
    font-family: "MontserratBold";
    text-transform: uppercase;
    margin-bottom: 0px;
}

.position-relative {
    position: relative;
}

.popup-enter-active,
.popup-leave-active {
    animation: fadeIn 0.3s ease-in-out, slideIn 0.3s ease-in-out;
}

.popup-leave-active {
    animation: fadeOut 0.3s ease-in-out, slideOut 0.3s ease-in-out;
}

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.popup-container {
    /* background-image: url('../assets/img/absolut-reg-form-bg.jpg'); */
    background-size: cover;
    background-color: var(--color-primary);
    background-position: center;
    padding: 24px;
    text-align: center;
    position: relative;
    border-radius: 30px;
    width: 100%;
    max-width: 540px;
    min-height: 440px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 16px;
}

.popup-content,
.popup-content-success {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}

.popup-close {
    position: absolute;
    top: 25px;
    right: 27px;
    background: none;
    border: none;
    color: #f2e4b5;
    cursor: pointer;
    z-index: 10;
    /* добавьте эту строку */
}

.popup-logo {
    width: auto;
    height: auto;
    margin-bottom: 38px;
    margin-top: 10px;
}

.popup-title {
    font-family: "jj2bold";
    font-weight: 700;
    font-size: 40px;
    text-transform: uppercase;
    text-align: center;
    color: #f2e4b5;
    margin-bottom: 31px;
}

.popup-text {
    font-family: "jj2bold";
    font-weight: 700;
    font-size: 36px;
    text-align: center;
    color: #f2e4b5;
    max-width: 346px;
    width: 100%;
    margin-bottom: 0px;
    line-height: 1.2;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

@keyframes slideIn {
    from {
        transform: translateY(-20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slideOut {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(-20px);
        opacity: 0;
    }
}
@media screen and (max-width: 566px){
    .otp-title {
        font-family: "MontserratBold";
        font-weight: 700;
        font-size: 20px;
    }
    .otp-description {
        font-family: "MontserratMedium";
        font-weight: 400;
        font-size: 15px;
    }
    .otp-success-text {
        font-size: 24px;
        line-height: 1.3;
        max-width: 100%;
        padding: 0 8px;
    }
    .sms-timer .resend-btn {
        font-family: "MontserratBold";
        font-weight: 400;
        font-size: 15px;
    }
    .btn-success {
        font-family: "MontserratBold";
        font-weight: 700;
        font-size: 16px;
        padding: 10px 32px;
        height: 50px;
    }
    .btn-container-success {
        margin-top: 24px;
    }
    .popup-container {
        min-height: 380px;
        height: auto;
        width: calc(100% - 32px);
        max-width: 100%;
        margin: 0 auto;
        padding: 32px 16px 20px 16px;
        border-radius: 24px;
    }
    .popup-content-success {
        padding: 24px 16px;
    }
    .position-relative {
        max-width: 275px !important;
    }
    ::v-deep .v-otp-input input {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: var(--color-primary) !important;
    }
}
</style>



<script>

export default {


    name: "otp",
    props: {
        showPopup: {
            type: Boolean,
            default: false,
        },
        smsTimer: {
            type: Number,
            default: 0
        },
        errorSms: {
            type: Boolean,
            default: false
        },
        success: {
            type: Boolean,
            default: false,
        }, // успешная верификация
        errorMessage: {
            type: String,
            default: ""
        },
        loading: {
            type: Boolean,
            default: false,
        }, // текст ошибки
    },
    data() {
        return {

            otp: '',
            expectedOtp: '1111',
            isSuccess: false,
            // timer: 60, // 60 секунд
            // timerInterval: null,
        };
    },
    methods: {

        confirmOtp() {
            this.$emit('verifyCode', this.otp);
        },

        closePopup() {
            this.otp = '';
            this.$emit('closePopup');
        },

    },
    watch: {
        showPopup(val) {
            if (val) {
                this.otp = '';
            }
        },
        otp(newVal) {
            console.log('OTP:', newVal);
        }
    },


    mounted() {
    }
}

</script>